import { useEffect } from 'react'
import { useThemeStore, applyColorsToDOM } from '@/stores/themeStore'

/**
 * Subscribes to theme store changes and applies DOM side effects
 * (class toggling + CSS custom properties). Call once at the app root.
 */
export function useThemeEffect() {
  const { theme, primaryColor, secondaryColor } = useThemeStore()

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    const resolved =
      theme === 'system'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light'
        : theme
    root.classList.add(resolved)
    applyColorsToDOM(primaryColor, secondaryColor, resolved === 'dark')
  }, [theme, primaryColor, secondaryColor])

  // Also listen for system theme changes when in 'system' mode
  useEffect(() => {
    if (theme !== 'system') return
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    const handler = (e: MediaQueryListEvent) => {
      const root = document.documentElement
      root.classList.remove('light', 'dark')
      root.classList.add(e.matches ? 'dark' : 'light')
      applyColorsToDOM(primaryColor, secondaryColor, e.matches)
    }
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [theme, primaryColor, secondaryColor])
}
